import * as THREE from "three";
import {SetupObstUI} from "./TransControl";
import { OBB } from 'three/examples/jsm/math/OBB';
import {Matrix4, Plane, Triangle, Vector3} from "three";
import { EditAction } from "../../../../../@types/enums";

export function SetWallMeshArr(self, interObj) {
    const {tabInfo} = self;
    if (interObj && tabInfo === 'Wall Sliding' && interObj.object.name.includes('wallMesh')) {
        const {select} = interObj.object;
        interObj.object.select = !select;
        SetSelWallMeshArr(self);
    }
}

function SetSelWallMeshArr(self) {
    const {wallMeshArr} = self, selWallArr = [];
    wallMeshArr.forEach(wallMesh => {
        const frameMesh = wallMesh.parent.children[1];
        frameMesh.visible = wallMesh.select;
        if (wallMesh.select) {
            selWallArr.push(wallMesh);
        }
    });
    self.selWallArr = selWallArr.length ? selWallArr : wallMeshArr;
}

export function ResetWallMeshArr(self) {
    self.wallMeshArr.forEach(wallMesh => {
        wallMesh.select = false;
        wallMesh.parent.children[1].visible = false;
    });
    self.obstGroup.children.forEach(group => {
        const inGroup = group.children[0].children[0];
        inGroup.children[0].select = false;
        inGroup.children[1].visible = false;
    });
    SetSelWallMeshArr(self);
    SetupObstUI(self);
}


const updateMeshTexture = (meshArr, map, color, type, self) => {
    const uuidArr = [], olderArr = [], newerArr = [];
    meshArr.forEach(mesh => {
        const oldMat = mesh.material, oldMap = oldMat.map, oldColor = oldMat.color.getHex();
        uuidArr.push(mesh.uuid);
        olderArr.push({map: oldMap, color: oldColor});
        newerArr.push({map, color});
        // mesh.material.dispose();
        var material;
        if (type === 'map') material = new THREE.MeshStandardMaterial({map});
        else if (type === 'color') material = new THREE.MeshStandardMaterial({color});
        mesh.material = material;
        mesh.oriMap = material.map;
        mesh.oriColor = material.color.getHex();
    })
    self.addStep(EditAction.MaterialChange, uuidArr, olderArr, newerArr);
};

export function ChangeMeshMaterial(meshArr, value, type, self, meshName, textureId) {
    if (meshArr.length === 0) return;

    if (type === 'map') {
        new THREE.TextureLoader().load(value, (map) => {
            if (meshName === 'wall') {
                //rotate texture 90 degrees
                map.rotation = Math.PI / 2;
            }
            map.wrapS = map.wrapT = THREE.RepeatWrapping;

            updateMeshTexture(meshArr, map, null, type, self)

            for (const mesh of meshArr) {
                mesh.userData.textureId = textureId;
                mesh.userData.color = undefined;
            }
        });

    } else if (type === 'color') {
        const color = new THREE.Color(value);
        updateMeshTexture(meshArr, null, color, type, self)

        for (const mesh of meshArr) {
            mesh.userData.textureId = undefined;
            mesh.userData.color = color;
        }
    }
}

export function SetMeshOBB(mesh) {
    mesh.geometry.computeBoundingBox();


    if(mesh.shapeNum===4 || mesh.geometry.type === 'BufferGeometry'){
        //polygon shape mesh ( geometry is buffer geometry )

    }
    else{
        //rectangle shape mesh
        mesh.geometry.userData.obb = new OBB().fromBox3(mesh.geometry.boundingBox);
    }

    mesh.userData.obb = new OBB();
}

export function SetWallMeshOBB(wall, center, firstPos) {
    SetMeshOBB(wall);
    wall.geometry.userData.obb.center = center.clone().sub(firstPos);

    wall.userData.center = center.clone();
    wall.userData.firstPos = {...firstPos};
}

export function UpdateMeshOBB(mesh, spacing) {

    if(mesh.shapeNum===4  || mesh.geometry.type === 'BufferGeometry'){
        //polygon shape mesh ( geometry is buffer geometry )

    }
    else {
        mesh.userData.obb.copy(mesh.geometry.userData.obb);
        mesh.userData.obb.applyMatrix4(mesh.matrixWorld);

        if (spacing) {
            mesh.userData.obb.halfSize.addScalar(spacing / 2);
        }
    }


}

export function UpdateWallMeshOBB(wall, spacing) {
    wall.updateWorldMatrix(true, false);
    UpdateMeshOBB(wall, spacing);
    wall.userData.obb.center = wall.userData.center;
}

export function DoesIntersectOBB(mesh1, mesh2) {


    if(mesh2.shapeNum===4 || mesh2.geometry.type === 'BufferGeometry') {

        const vertices = mesh2.geometry.attributes.position.array;
        const indices = mesh2.geometry.index.array;

        const triangle = new Triangle();
        const a = new Vector3();
        const b = new Vector3();
        const c = new Vector3();

        for (let i = 0; i < indices.length; i += 3) {
            a.fromArray(vertices, indices[i] * 3);
            b.fromArray(vertices, indices[i + 1] * 3);
            c.fromArray(vertices, indices[i + 2] * 3);

            triangle.set(a, b, c);

            if (mesh1.userData.obb.intersectsTriangle(triangle)) {
                return true;
            }
        }


        const mesh1Vertices = mesh1.geometry.attributes.position.array;
        const pointInside = new Vector3();

        for (let i = 0; i < mesh1Vertices.length; i += 3) {
            pointInside.fromArray(mesh1Vertices, i);
            pointInside.applyMatrix4(mesh1.matrixWorld);

            if ( isPointInsidePolygon(pointInside, mesh2)) {
                return true;
            }


        }


        const raycaster1 = new THREE.Raycaster();
        const raycaster2 = new THREE.Raycaster();
        const center = new Vector3();
        center.copy(mesh1.userData.obb.center);


        const upwardCenter = new Vector3();
        upwardCenter.copy(center)
        upwardCenter.y -= 1;

        const downwardCenter = new Vector3();
        downwardCenter.copy(center)
        downwardCenter.y += 1;

        const upwardDir = new Vector3(0, 1, 0).normalize()

        raycaster1.set(upwardCenter, upwardDir);


        const downwardDir = new Vector3(0, -1, 0).normalize()
        raycaster2.set(downwardCenter, downwardDir);


        const intersects = raycaster1.intersectObject(mesh2);
        const intersects2 = raycaster2.intersectObject(mesh2);


        const combinedIntersects = intersects.concat(intersects2).filter(intersect => intersect.object.geometry.type !== "EdgesGeometry");


        if (combinedIntersects.length > 0) {
            return true;
        }

    }


    return mesh1.userData.obb.intersectsOBB(mesh2.userData.obb);
}



function isPointInsidePolygon(point, polygonMesh) {
    const vertices = polygonMesh.geometry.attributes.position.array;
    const indices = polygonMesh.geometry.index.array;

    const triangle = new Triangle();
    const a = new Vector3();
    const b = new Vector3();
    const c = new Vector3();
    const plane = new Plane();

    let inside = true;

    // Check if the point is inside all the triangles
    for (let i = 0; i < indices.length; i += 3) {
        a.fromArray(vertices, indices[i] * 3);
        b.fromArray(vertices, indices[i + 1] * 3);
        c.fromArray(vertices, indices[i + 2] * 3);

        triangle.set(a, b, c);
        plane.setFromCoplanarPoints(a, b, c);

        if (plane.distanceToPoint(point) > 0) {
            inside = false;
            break;
        }
    }

    return inside;
}



function getOBBInverseMatrix(obb, target = new Matrix4()) {

    target.identity();
    const rotationMatrix4 = new Matrix4();
    rotationMatrix4.setFromMatrix3(obb.rotation);

    target.multiply(new Matrix4().makeTranslation(obb.center.x, obb.center.y, obb.center.z));
    target.multiply(rotationMatrix4);

    target.invert();

    return target;
}

function aabbIntersectsTriangle(aabbHalfSize, v0, v1, v2) {


    const minMax = (out, ...values) => {
        out[0] = Math.min(...values);
        out[1] = Math.max(...values);
    };

    let r0 = v0.x, r1 = v1.x, r2 = v2.x;
    let rangeX = [0, 0]; // [min, max]
    minMax(rangeX, r0, r1, r2);
    if (rangeX[1] < -aabbHalfSize.x || rangeX[0] > aabbHalfSize.x) {
        return false;
    }

    r0 = v0.y; r1 = v1.y; r2 = v2.y;
    let rangeY = [0, 0];
    minMax(rangeY, r0, r1, r2);
    if (rangeY[1] < -aabbHalfSize.y || rangeY[0] > aabbHalfSize.y) {
        return false;
    }

    r0 = v0.z; r1 = v1.z; r2 = v2.z;
    let rangeZ = [0, 0];
    minMax(rangeZ, r0, r1, r2);
    if (rangeZ[1] < -aabbHalfSize.z || rangeZ[0] > aabbHalfSize.z) {
        return false;
    }

    const f1 = new Vector3();
    const f2 = new Vector3();
    const normal = new Vector3();

    const e0 = new Vector3().subVectors(v1, v0);
    const e1 = new Vector3().subVectors(v2, v1);
    const e2 = new Vector3().subVectors(v0, v2);

    normal.crossVectors(e0, e1);


    const r =
        aabbHalfSize.x * Math.abs(normal.x) +
        aabbHalfSize.y * Math.abs(normal.y) +
        aabbHalfSize.z * Math.abs(normal.z);

    // Project v0 (v1, v2) on the normal, check min/max
    const dist0 = normal.dot(v0);
    const dist1 = normal.dot(v1);
    const dist2 = normal.dot(v2);
    const triMin = Math.min(dist0, dist1, dist2);
    const triMax = Math.max(dist0, dist1, dist2);

    if (triMax < -r || triMin > r) {
        return false; // no overlap
    }


    const testAxis = (axis, v0, v1, v2, aabbHalf) => {

        const p0 = v0.dot(axis);
        const p1 = v1.dot(axis);
        const p2 = v2.dot(axis);
        const minP = Math.min(p0, p1, p2);
        const maxP = Math.max(p0, p1, p2);


        const rAABB =
            aabbHalf.x * Math.abs(axis.x) +
            aabbHalf.y * Math.abs(axis.y) +
            aabbHalf.z * Math.abs(axis.z);

        if (maxP < -rAABB || minP > rAABB) {
            return false;
        }
        return true;
    };

    const aabbAxes = [
        new Vector3(1,0,0),
        new Vector3(0,1,0),
        new Vector3(0,0,1),
    ];


    for (const edge of [ e0, e1, e2 ]) {
        for (const axis of aabbAxes) {
            const crossAxis = new Vector3().crossVectors(edge, axis);
            if (crossAxis.lengthSq() < 1e-10) {
                continue;
            }
            if (!testAxis(crossAxis.normalize(), v0, v1, v2, aabbHalfSize)) {
                return false;
            }
        }
    }
    return true;
}


export function patchOBBForTriangleIntersection(OBBClass) {
    OBBClass.prototype.intersectsTriangle = function(tri) {
        const invMat = getOBBInverseMatrix(this);

        const v0 = tri.a.clone().applyMatrix4(invMat);
        const v1 = tri.b.clone().applyMatrix4(invMat);
        const v2 = tri.c.clone().applyMatrix4(invMat);

        return aabbIntersectsTriangle(this.halfSize, v0, v1, v2);
    };
}


export function disposeObject(object) {
    // Traverse all descendants and dispose of their resources
    object.traverse(child => {
        if (child.isMesh) {
            // Dispose of geometry and material resources
            if (child.geometry) {
                child.geometry.dispose();
            }
            if (child.material) {
                // Check if the material is an array or a single material
                if (Array.isArray(child.material)) {
                    for (const material of child.material) {
                        disposeMaterial(material);
                    }
                } else {
                    disposeMaterial(child.material);
                }
            }
        }
    });

    // Remove all children from the object itself (optional, as traverse handles them,
    // but ensures the object is empty if it's reused)
    while (object.children.length > 0) {
        disposeObject(object.children[0]);
    }

    // Remove the object from its parent
    if (object.parent) {
        object.parent.remove(object);
    }
}


export function disposeMaterial(material) {
    // Dispose of textures associated with the material
    for (const key of Object.keys(material)) {
        const value = material[key];
        if (value && value.isTexture) {
            value.dispose();
        }
    }
    // Dispose of the material itself
    material.dispose();
}
